import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { AppDispatch } from '@store/types'
import { logoutThunk } from '@store/features/auth/auth.actions'
import Oops from './components/Oops'

interface IErrorBoundaryInnerProps {
  logoutThunk: () => void
  children: React.ReactNode
  locationKey: string
}

interface IErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundaryInner extends React.Component<IErrorBoundaryInnerProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryInnerProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: IErrorBoundaryInnerProps) {
    if (this.state.hasError && prevProps.locationKey !== this.props.locationKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      if (process.env.NODE_ENV === 'production') {
        this.props.logoutThunk()
      }

      return <Oops />
    }

    return this.props.children
  }
}

const ConnectedErrorBoundary = connect(null, (dispatch: AppDispatch) => ({
  logoutThunk: () => dispatch(logoutThunk())
}))(ErrorBoundaryInner)

const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()

  return (
    <ConnectedErrorBoundary locationKey={location.key}>{children}</ConnectedErrorBoundary>
  )
}

export default ErrorBoundary
